/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_More_ActionsInputs */



/**
* | output |
* | --- |
* | "More actions" |
*
* @param {Meeting_More_ActionsInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_more_actions = /** @type {((inputs?: Meeting_More_ActionsInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_More_ActionsInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Meer acties")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Plus d'actions")
	return /** @type {LocalizedString} */ ("More actions")
});